import { TGetLinkPropsFn } from './types'

export const getLinkPropsMakeNullable =
  <T = $TSFixMe>(fn: TGetLinkPropsFn<T>): TGetLinkPropsFn<T> =>
  (val, ...rest) => {
    if (val) return fn(val, ...rest)
    return { children: undefined, to: () => `` }
  }
